import { render, staticRenderFns } from "./MyText.vue?vue&type=template&id=2a7a7dca&"
import script from "./MyText.vue?vue&type=script&lang=js&"
export * from "./MyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports